export default __webpack_public_path__ + "static/media/formMailIcon.88456a62.svg";